// @ts-nocheck
import mbw from './mbw.png';
import mb from './mb.png';
import creditCard from './ccc.png';
import directDebit from './cc.png';
import cofidis from './cofidis.png';
import paysafecard from './paysafecard.png';
import paysafecash from './paysafecash.png';
import santander from './santander.png';

const serviceImages = {
  MBWay: mbw,
  Multibanco: mb,
  CreditCard: creditCard,
  DirectDebit: directDebit,
  Cofidis: cofidis,
  Paysafecard: paysafecard,
  Paysafecash: paysafecash,
  Santander: santander,
};

export default serviceImages;
